import React, { useContext, useEffect, useRef, useState } from "react";
import { useAPI  } from "../API";
import moment from "moment";

import ListGroup from "react-bootstrap/ListGroup";
import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { useLocalizedStrings } from "../Localization";
import { InformationCircleIcon } from "@heroicons/react/solid";
import { ClickableButton } from "../Components/Button";
import { SpacedSpinner } from "../Util";
import { ConfigurationContext } from "../Context";

type HistoryProps = { uid: string, canViewChanges: boolean }

function History(props: HistoryProps){

    const L = useLocalizedStrings();
    const [itemCount, setItemCount] = useState(20);
    const isLoading = useRef(false);
    const config = useContext(ConfigurationContext);

    const [history, refreshHistory] = useAPI(
        "/applicant/" + props.uid + "/history",
        true
    );

    useEffect(() => {
        if (!isLoading.current) {
            (async () => {
                isLoading.current = true;
                await refreshHistory();
                isLoading.current = false;
            })();
        }
    }, [itemCount]);

    async function updateHistoryItems(event: any) {
        if (event.target.value === 'All'){
            setItemCount(-1);
        }else{
            setItemCount(event.target.value);
        }
    }

    return (
        <div className="max-w-md">
            <Row key="master-history" className="mb-2">
                <Col>{L.applicant.history.number_of_changes}</Col>
                <Col className="ml-auto">
                    <Form.Control as="select" size="sm" 
                        disabled={isLoading.current}
                        custom
                        onChange={(e) => updateHistoryItems(e)}
                        defaultValue={itemCount}>
                        <option>{'20'}</option>
                        <option>{'100'}</option>
                        <option>{'200'}</option>
                        <option>{L.applicant.history.all}</option>
                    </Form.Control>
                </Col>
                <ClickableButton color="blue" 
                    disabled={isLoading.current}
                    extraClasses="bg-blue-200" onClick={() => refreshHistory()}>
                    {isLoading.current && <SpacedSpinner />}{L.applicant.history.refresh}
                </ClickableButton>
            </Row>
            <ListGroup>
                {history &&
                    history.changes &&
                    history.changes.slice(0, itemCount).map((i: any) => {
                        const popover = (
                        <Popover id={i.id + '_popover'} key={i.id + '_popover'}>
                            <Popover.Title>{i.key}</Popover.Title>
                            <Popover.Content style={{
                                maxHeight: '80vh',
                                overflowY: 'scroll'
                            }}>
                                {i.value}
                            </Popover.Content>
                        </Popover>);

                        const metadataPopover = (
                            <Popover id={i.id + '_metadata'} key={i.id + '_metadata'}>
                                <Popover.Title>{L.campaigns.metadata}</Popover.Title>
                                <Popover.Content style={{
                                    maxHeight: '80vh',
                                    overflowY: 'scroll'
                                }}>
                                    {i.metadata}
                                </Popover.Content>
                            </Popover>
                        );

                        return (
                            <ListGroup.Item key={i.id + '_history'}>
                                {i.latest ? <Badge variant="success">{L.applicant.history.latest}</Badge> : ''}
                                <div className={`break-all break-works` + (!i.latest ? 'old-history' : '')}>
                                    {i.key}:&nbsp;
                                    {i.value.length > 50 ? 
                                        <>
                                        <br/>
                                        <OverlayTrigger trigger="click" placement="right" 
                                            overlay={popover}>
                                            <Button variant="link" 
                                                title={L.applicant.history.click_to_show}>
                                                    {L.applicant.history.click_to_show}
                                            </Button>
                                        </OverlayTrigger> 
                                        </> : i.value}
                                    <br/>
                                    <div className="flex flex-row space-between">
                                        <div className="my-auto">
                                            {L.applicant.history.by} {i.author_name ? i.author_name : 'system'}, {
                                                config.roles?.includes('admin') 
                                                    ? moment.unix(i.created_at).toISOString()
                                                    : moment.unix(i.created_at).calendar()
                                            }
                                        </div>
                                        {(config.roles || '').indexOf('admin') !== -1 && (
                                        <div className="my-auto ml-auto">
                                            <small className="text-gray-500">
                                                <OverlayTrigger trigger="click" placement="right"
                                                    overlay={metadataPopover}>
                                                        <Button variant="link" className="text-sm" title={L.campaigns.metadata}>
                                                            <InformationCircleIcon className="h-6 w-6 text-gray-500" />
                                                        </Button>
                                                    </OverlayTrigger>
                                            </small>
                                        </div>)}
                                    </div>

                                </div>
                            </ListGroup.Item>
                        );
                    })}
            </ListGroup>
        </div>
    );

}

export default History;